import React, { ReactNode, useEffect } from 'react'
import { useCrewInfo } from '../../hooks'
import { useMutation, useQuery } from 'react-query'
import { FormProvider, useForm } from 'react-hook-form'
import { ApiErrorType, CrewSingleGetType, CrowDocItem, DocumentType, JobLevelType, ListResponseType, ResponseType, ResponseTypeDoc } from 'src/types'
import { Get, Post } from 'src/apis/apiWithType'
import { Get as JSGet } from 'src/apis/api'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { Button, InputField } from 'src/components/UI'
import { toast } from 'react-toastify'
import { AxiosResponse } from 'axios'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { createFileURL } from 'src/utils/new'
import { Close } from 'src/icons/icons'
import Loading from 'src/components/Loading'
import { EachDoc } from './components/EachDoc'


export interface FormType { [key: string]: { file: FileList | string, doc_number?: string, expire_date?: string } }
export const Documents = () => {

    const { step, selectedCrew } = useCrewInfo()

    const { t } = useTranslation()

    const [params] = useSearchParams()

    const mode = params.get('mode')

    const crewId = params.get('id')

    const user = useSelector((state) => (state as any).user.user)

    const isAdmin = user?.role_key === "super_admin"

    const path = isAdmin ? 'admin' : 'agent'


    const { data, isLoading } = useQuery<ResponseType<JobLevelType>>({
        queryFn: ({ queryKey }) => Get(`basic-information/job-levels/show/${queryKey[1]}`),
        // queryKey: ['LevelInfo', 4 ? 4 : selectedCrew?.level_id],
        queryKey: ['LevelInfo', selectedCrew?.level_id],
        enabled: !!selectedCrew?.level_id && mode == 'add'
    })

    const { data: docsData, isLoading: loadingOfDocs, refetch } = useQuery<ResponseTypeDoc<CrowDocItem[]>>({
        queryFn: ({ queryKey }) => Get(`/${path}/crews/crewdoc/${queryKey?.[1]}`) as unknown as any,
        // queryKey: ['GetCrewDoc', 22],
        queryKey: ['GetCrewDoc', crewId],
        enabled: !!crewId
    })

    const { data: crewInfoData, isLoading: loadingOfCrew } = useQuery<ResponseType<CrewSingleGetType>, ApiErrorType>({
        queryFn: ({ queryKey }) => Get(`${path}/profile/crews/${queryKey?.[1]}`),
        queryKey: ['GetCrewInfo', crewId],
        enabled: !!crewId && mode == 'edit',
        onError: (error) => {
            toast.error(error?.data?.message)
        }
    })




    const { mutate, isLoading: loadingSending, isSuccess, status } = useMutation<Array<ResponseType<any>>, ApiErrorType[] | ApiErrorType, FormType>({
        mutationFn: async (data) => {

            const newArray = Object.values(data)
                .map((i, index) => ({
                    file: i?.file?.[0] instanceof File ? i.file?.[0] : undefined,
                    doc_no: i.doc_number,
                    expire_date: i.expire_date,
                    document_id: Object.keys(data)[index]
                }))
                .filter(i => i.file instanceof File)



            return await Promise.all(newArray.map(async i => {

                const formData = new FormData()

                formData.append('files[0][document_id]', i.document_id)
                if (i?.doc_no)
                    formData.append('doc_no', i?.doc_no)
                if (i.expire_date)
                    formData.append('expire_date', i.expire_date)
                if (i.file)
                    formData.append('files[0][file]', i.file)
                formData.append('form', 'new_upload_files')


                return Post(`admin/crews/${mode == 'add' ? selectedCrew?.id : crewInfoData?.details.data.id}/v2-upload-files`, formData)

            }
            ))
            // return Post(`admin/crews/${34}/v2-upload-files`, formData)

        },
        mutationKey: ['UploadDocs', selectedCrew?.id],
        onSuccess: (res) => {
            toast.success(res?.[0].msg)
            refetch()
        },
        onError: (errorResponse) => {

            if (Array.isArray(errorResponse))
                errorResponse?.forEach(res => toast.error(res?.data?.message))
            else toast.error(errorResponse?.data?.message)

        }

    })


    const methods = useForm<FormType>()

    const { register, formState: { errors }, handleSubmit, reset, getValues, watch, setValue, resetField } = methods

    console.log({ errors })

    const handleMutate = (data: FormType) => {
        mutate(data)
    }


    useEffect(() => {
        if (docsData?.details?.doc && docsData?.details?.doc?.length > 0) {

            const newFormData = docsData?.details?.doc.reduce((pv, cv) => {
                pv = { ...pv, [cv.document_id]: { file: cv.filepath, doc_number: cv.doc_no, expire_date: cv.expire_date } }
                return pv
            }, {})

            reset(newFormData)
        }
    }, [docsData])


    const DeleteWrapper = ({ children, id }: { children: ReactNode, id: string }) => <div className='flex flex-row gap-4 items-center text-sm'>
        {children}
        <div onClick={() => setValue(`${id}.file`, '')} className='cursor-pointer'><Close color='red' /></div>
    </div>

    const PreviewComponent = ({ id, title, is_optional }: DocumentType) => {

        const targetFile = watch(`${id}`)


        if (typeof targetFile?.file == 'string' && targetFile.file?.length > 1)
            return <DeleteWrapper id={id}><button className='bg-primary-300 rounded-lg text-white flex flex-row gap-2 items-center p-2' onClick={() => window.open(createFileURL(targetFile?.file as string))} type='button'>{t('see')}</button></DeleteWrapper>

        else if (targetFile?.file instanceof FileList && targetFile.file?.[0]) {
            return <DeleteWrapper id={id}><button className='bg-primary-300 rounded-lg text-white flex flex-row gap-2 items-center p-2' onClick={() => window.open(URL.createObjectURL(targetFile?.file[0] as Blob))} type='button'>{t('seeSelectedFile')}</button></DeleteWrapper>

        }

        return <input type='file' id={`doc-${id}`} {...register(`${id}.file`, { deps: [`${id}.doc_number`, `${id}.expire_date`], required: { value: !!watch(`${id}.doc_number`) || !!watch(`${id}.expire_date`), message: `${t('File')} ${title} ${t('IsRequired')}` } })} />

    }



    if (loadingOfDocs || loadingOfCrew)
        return <>
            <div className='lg:hidden  flex-row flex justify-center w-full bg-white rounded-lg p-8 '><Loading /></div>
            <div className='hidden lg:flex  flex-row gap-4 items-center  my-container bg-white w-full justify-center p-8 py-10  text-gray-700 rounded-lg'><Loading /></div>
        </>

    return (
        <FormProvider {...methods}>

            <form className='flex flex-col gap-4 my-container mt-2' onSubmit={handleSubmit(handleMutate)}>


                {isLoading && <div className='flex flex-col gap-2'>
                    {Array.from(new Array(5)).map(item => <div className='w-full bg-gray-100 animate-pulse h-16 rounded-lg'></div>)}
                </div>}

                <div className='flex flex-col gap-4 items-stretch '>

                    {(mode == 'edit' ? (crewInfoData?.details?.data.level.documents ?? []) : (data?.details.data.documents ?? [])).map((item, index) => <EachDoc
                        status={status}
                        mode={mode}
                        record={{ ...item, index }} />)}

                    {/* {(mode == 'edit' ? (crewInfoData?.details?.data.level.documents ?? []) : (data?.details.data.documents ?? [])).map((item, index) => <div className={clsx('border rounded-lg flex flex-col lg:flex-row  gap-4 lg:gap-10 lg:items-center p-3 bg-white justify-between flex-wrap', !!errors?.[`${item.id}`] && 'border-red')}>

                        <div className='flex flex-row gap-4 lg:gap-8 items-center flex-1  '>
                            <div className='bg-primary-300 rounded-full  p-2 aspect-square shrink-0 w-8 h-8 flex flex-row justify-center items-center text-white'>
                                {index + 1}
                            </div>

                            <span className=' text-center'>{item.title}</span>
                        </div>

                        <div className={'flex flex-row gap-8 items-center flex-1 justify-between'} >


                            <div className='flex flex-col lg:flex-row gap-8 items-start lg:items-center justify-between flex-1'>
                                <InputField
                                    label={`${t('number')} (${t('Optional')})`}
                                    {...register(`${item.id}.doc_number`)}
                                // className='w-32'

                                />


                                <InputField
                                    label={`${t('ExpireDate')} (${t('Optional')})`}
                                    {...register(`${item.id}.expire_date`)}
                                    // className='w-32'
                                    type='date'
                                    style={{ display: 'ltr' }}
                                />
                            </div>




                        </div>
                        <div className='flex-1 flex flex-row justify-end items-center gap-2'>

                            {!!errors?.[`${item.id}`]?.file && <span className='text-red text-sm text-center whitespace-nowrap'>{errors?.[`${item.id}`]?.file?.message}</span>}
                            <PreviewComponent {...item} />
                        </div>




                    </div>)} */}
                </div>
                {mode=='edit' && <span className='text-sm text-orange-500 font-bold'>
                    {t('ForChangeDocumentInfoYouShouldUploadDocAgain')}
                </span>}

                <div className='flex flex-row justify-end '>
                    <Button loading={loadingSending} style={{ width: 'fit-content' }} keyTitle={mode == 'add' ? 'SendDocuments' : 'updateDocuments'}></Button>
                </div>

            </form>
        </FormProvider>
    )
}
